import CustomInput from "@/components/common/customInput";
import { styled, TextField } from "@mui/material";

const TextFieldStyled = styled(CustomInput)(({ theme }) => ({
  color: "#D9D9D9",
  width: "100%",
  marginBlockStart: 0,
  "& .MuiInputBase-root": {
    marginTop: "0",
    borderRadius: "16px",
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00C37A",
        borderWidth: "2px",
      },
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00C37A",
        borderWidth: "2px",
      },
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "16px",
    borderColor: "#E0E0E0",
    borderWidth: "1.5px",
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: "#00C37A",
  },
  "& .MuiFormLabel-root.MuiFormLabel-root": {
    fontSize: "1rem",
    color: "#000",
  },
  "& .MuiFormLabel-root.Mui-focused.MuiInputLabel-shrink": {
    color: "#00C37A",
    // opacity: "0.6",
    fontSize: "1rem",
  },
  "& .MuiInput-underline:before": {
    borderBottom: "1px solid #000",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottom: "2px solid #00C37A",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "2px solid #00C37A",
  },
  "& .MuiFormHelperText-root": {
    // fontSize: "22px",
    // fontSize: "14px",
    fontWeight: "800",
  },
  "& .MuiInputBase-input": {
    textTransform: "capitalize",
    marginTop: "0",
    borderRadius: "16px",
  },
  "& .MuiInputBase-input::placeholder": {
    textTransform: "initial",
  },
}));

export default TextFieldStyled;
